import { render, staticRenderFns } from "./DailyMilkRecordingTable.vue?vue&type=template&id=4f616691&scoped=true&"
import script from "./DailyMilkRecordingTable.vue?vue&type=script&lang=js&"
export * from "./DailyMilkRecordingTable.vue?vue&type=script&lang=js&"
import style0 from "./DailyMilkRecordingTable.vue?vue&type=style&index=0&id=4f616691&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f616691",
  null
  
)

export default component.exports